
export function CSSCourse() {
    return (
        <main id="main" className="site-main" role="main">
		   <article id="post-80" className="post-80 page type-page status-publish hentry">
			  <div className="entry-content">
				 <p data-adtags-visited="true"><strong>Topic 1: CSS Introduction</strong></p>
				 <ul>
					<li>Benefits of CSS</li>
					<li>CSS Versions History</li>
					<li>CSS Syntax</li>
					<li>External Style Sheet using</li>
					<li>Multiple Style Sheets</li>
				 </ul>
				 <p data-adtags-visited="true"><strong>Topic 2: CSS Selectors</strong></p>
				 <ul>
					<li>ID Selectors</li>
					<li>Class Selectors</li>
					<li>Grouping Selectors</li>
					<li>Universal Selector</li>
					<li>Descendant / Child Selectors</li>
					<li>Attribute Selectors</li>
					<li>
					   Pseudo Elements
					   <ul>
						  <li>First line, Multiple, After, Before</li>
					   </ul>
					</li>
					<li>
					   Pseudo Class
					   <ul>
						  <li>Hover, Focus, Child, Link, Active, etc</li>
					   </ul>
					</li>
				 </ul>
				 <p data-adtags-visited="true"><strong>Topic 3: CSS Color Background &amp; CSS Text</strong></p>
				 <ul>
					<li>
					   Background
					   <ul>
						  <li>background-image</li>
						  <li>background-repeat</li>
						  <li>background-position</li>
					   </ul>
					</li>
					<li>
					   Text Fonts
					   <ul>
						  <li>Text Colors</li>
						  <li>Text Fonts</li>
						  <li>Text Alignments</li>
						  <li>Background color</li>
						  <li>Text Spacing</li>
						  <li>Font weight</li>
					   </ul>
					</li>
				 </ul>
				 <p data-adtags-visited="true"><strong>Topic 4: CSS Cursors &amp; Scrollbars</strong></p>
				 <ul>
					<li>Cursor types</li>
					<li>Scroll bars</li>
				 </ul>
				 <p><strong>Topic 5: CSS Lists &amp; Buttons</strong></p>
				 <ul>
					<li>list-style-type</li>
					<li>list-style-position</li>
					<li>list-style-image</li>
					<li>list-style</li>
					<li>Button styles</li>
				 </ul>
				 <p><strong>Topic 6: CSS Tables</strong></p>
				 <ul>
					<li>border</li>
					<li>width &amp; height</li>
					<li>text-align</li>
					<li>vertical-align</li>
					<li>padding</li>
					<li>color</li>
				 </ul>
				 <p><strong>Topic 7: CSS Box Model</strong></p>
				 <ul>
					<li>Borders &amp; Outline</li>
					<li>Margin &amp; Padding</li>
					<li>Height and width</li>
					<li>CSS Dimensions</li>
				 </ul>
				 <p><strong>Topic 8: CSS Display Positioning</strong></p>
				 <ul>
					<li>CSS Visibility</li>
					<li>CSS Display</li>
					<li>
					   CSS Positioning
					   <ul>
						  <li>Static Positioning</li>
						  <li>Fixed Positioning</li>
						  <li>Relative Positioning</li>
						  <li>Absolute Positioning</li>
					   </ul>
					</li>
					<li>CSS Popup with Z-Index</li>
				 </ul>
				 <p><strong>Topic 9: CSS Floats &amp; CSS Icons</strong></p>
				 <ul>
					<li>
					   CSS Floats
					   <ul>
						  <li>The float Property</li>
						  <li>The clear Property</li>
						  <li>The clear fix Hack</li>
					   </ul>
					</li>
					<li>
					   &nbsp;CSS Icons
					   <ul>
						  <li>Font Awesome Icons</li>
					   </ul>
					   <ul>
						  <li>Bootstrap Icons</li>
					   </ul>
					   <ul>
						  <li>Google Icons</li>
					   </ul>
					</li>
				 </ul>
				 <p><strong>Topic 10: CSS Navigation Bar</strong></p>
				 <ul>
					<li>Navbar</li>
					<li>Vertical</li>
					<li>Horizontal</li>
				 </ul>
				 <p><strong>Topic 11: Dropdown</strong></p>
				 <ul>
					<li>Basic Dropdown</li>
					<li>Dropdown Menu</li>
					<li>Right, Left Aligned dropdowns</li>
				 </ul>
				 <p><strong>Topic 12: CSS Layouts &amp; Forms</strong></p>
				 <ul>
					<li>
					   Layouts
					   <ul>
						  <li>1-column</li>
					   </ul>
					   <ul>
						  <li>2-column</li>
					   </ul>
					   <ul>
						  <li>3-column</li>
					   </ul>
					</li>
					<li>
					   Forms
					   <ul>
						  <li>Input fields</li>
					   </ul>
					   <ul>
						  <li>Padded Inputs</li>
					   </ul>
					   <ul>
						  <li>Bordered Inputs</li>
					   </ul>
					   <ul>
						  <li>Colored Inputs</li>
					   </ul>
					   <ul>
						  <li>Focused Inputs</li>
					   </ul>
					</li>
				 </ul>
				 <p><strong>Topic 13: CSS Responsive</strong></p>
				 <ul>
					<li>View Port</li>
					<li>Grid View</li>
					<li>Media Queries</li>
				 </ul>
				 <p><strong>Topic 14: Grid Layout</strong></p>
				 <ul>
					<li>Grid Element</li>
					<li>Display</li>
					<li>Grid Columns, Rows &amp; Gaps</li>
					<li>Grid Lines</li>
					<li>Grid Container</li>
					<li>Grid Item</li>
				 </ul>
			  </div>
		   </article>
		</main>
    )
}